// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ForgottenPasswordForm_errorContainer__jybSj","errorMessage":"ForgottenPasswordForm_errorMessage__nwQhB"};